// extracted by mini-css-extract-plugin
export default {"-large":"QG7GSPdT4GUtIk85bAXv","footer":"EnrCefwHIcZDyhunQMpY","audienceName":"PStiQQnqZSUGSBkaTyCv"};